import useMutationApi from 'src/api/useMutationApi';

interface UpdateLineItemFieldData {
  lineItemId: string;
  field: 'quantity' | 'unitPrice' | 'rescheduledDate' | 'ediRejected';
  value: number | string | boolean;
  sendAcknowledgment?: boolean;
}

const useUpdateSalesOrderLineItem = (
  salesOrderId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<UpdateLineItemFieldData>({
    endpoint: `accounts-receivable/sales-orders/${salesOrderId}/line-item`,
    method: 'PATCH',
    options: {
      onSuccess: onSuccess
        ? () => {
            onSuccess();
          }
        : undefined,
    },
  });
};

export default useUpdateSalesOrderLineItem;
